import React, { Component } from 'react';
import Wrapper from './../../../../common/component/Wrapper';
import {
    getTitleTable, formatMoney, columnsTable,
    getDataSource
} from '../../../../../../helpers/functions';

import { DATE_TIME_FORMAT } from '../../../../../../constants/Define';
import { FormWrapperItem, ListComponent } from '../../../../common/component/Index';
import Span from './../../../../common/component/Span';
import EllipsisText from './../../../../common/component/EllipsisText';
import RedeemtionDetail from './RedeemtionDetail';
import { Popover } from 'antd';

import { isEqual } from 'lodash';
import './RedeemtionList.less';

let permisionActions = [];
const defaultState = {

};

const ReportListCols = [
    'groupName', 'properties', 'saleStartDate', 'saleEndDate',
    'originalPrice', 'salePrice', 'openingStock', 'closingStock',
    'increase', 'decrease', 'usedCount', 'groupId', 'detail'
];
export default class RedeemtionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(ReportListCols, [], ['groupId', 'detail']),
            modelItem: ReportListCols,
            componentTable: {
                groupName: {
                    sorter: (i, k) => i.groupName.length - k.length,
                    key: 'groupName',
                    width: 250,
                    render: (text, record) => <EllipsisText title={this.props.t(`item.report.groupName`)}
                        content={text} contentMaxWidth={250}
                        overlayClassName={'max-width-500'} overlayComponent={Popover} />,
                },
                properties: {
                    sorter: (i, k) => i.properties.length - k.length,
                    key: 'properties',
                    align: 'right',
                },
                saleStartDate: {
                    render: (text, record) => record.saleStartDate && record.saleStartDate.format(DATE_TIME_FORMAT.SHORT_DATE),
                    sorter: (i, k) => i.saleStartDate.length - k.length,
                    key: 'saleStartDate',
                },
                saleEndDate: {
                    render: (text, record) => record.saleEndDate && record.saleEndDate.format(DATE_TIME_FORMAT.SHORT_DATE),
                    sorter: (i, k) => i.saleEndDate.length - k.length,
                    key: 'saleEndDate',
                },
                originalPrice: {
                    render: (text, record) => formatMoney(record.originalPrice || '') + this.props.t('currencySymbol'),
                    sorter: (i, k) => i.originalPrice.length - k.length,
                    key: 'originalPrice',
                    align: 'right',
                },
                salePrice: {
                    render: (text, record) => formatMoney(record.salePrice || '') + this.props.t('currencySymbol'),
                    sorter: (i, k) => i.salePrice.length - k.length,
                    key: 'salePrice',
                    align: 'right',
                },
                openingStock: {
                    sorter: (i, k) => i.openingStock.length - k.length,
                    key: 'openingStock',
                    align: 'right',
                },
                increase: {
                    sorter: (i, k) => i.increase.length - k.length,
                    key: 'increase',
                    align: 'right',
                },
                decrease: {
                    sorter: (i, k) => i.decrease.length - k.length,
                    key: 'decrease',
                    align: 'right',
                },
                usedCount: {
                    sorter: (i, k) => i.usedCount.length - k.length,
                    key: 'usedCount',
                    align: 'right',
                },
                closingStock: {
                    sorter: (i, k) => i.closingStock.length - k.length,
                    key: 'closingStock',
                    align: 'right',
                },
            },
            expandedRows: [],
        };
    }

    render() {
        const { t, data, loading } = this.props;
        const { voucherRedeemtions } = data;
        const { titleItemTable, modelItem, componentTable, expandedRows } = this.state;

        return (
            <Wrapper className="mt-3 redeemtion-list">
                <ListComponent
                    tableKey="report-redeemtion-list"
                    scroll={{ x: 1500 }}
                    classParent="m-0 p-0 col-md-12" classChildren="p-0"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => record.groupId ? record.groupId : k}
                    dataSource={getDataSource(voucherRedeemtions || [], modelItem)}
                    columns={columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'report'
                    })}
                    pagination={{ total: data.totalCount, totalPage: data.totalPage, current: data.pageIndex, pageSize: data.pageSize }}
                    onChange={this.onTableChange}
                    componentTableList={{}}
                    expandedRowRender={this.renderRedeemtionDetail}
                    onExpand={this.onRowExpanded}
                    expandedRowKeys={expandedRows}
                    onExpandedRowsChange={expandedRows => this.setState({ expandedRows })}
                />
            </Wrapper>
        );
    }

    renderRedeemtionDetail = (record, index, indent, expanded) => {
        const { data } = this.props;
        
        return (
            <RedeemtionDetail
                data={record.detail}
                loading={data.loadingGroup && data.loadingGroup === record.groupId}
                onTableChange={(pagination, filters, sorter) => this.props.onDetailTableChange(record, pagination, filters, sorter)}
            />
        )
    }

    renderEllipsisText = (title, text, maxWidth = 100, className = undefined) => {
        return (
            <Popover trigger="hover" title={title} content={text} overlayClassName={className}>
                <Span className="text-ellipsis" style={{ maxWidth }}>{text}</Span>
            </Popover>
        )
    }

    onRowExpanded = (expanded, record) => {
        if (expanded && record.groupId) {
            this.props.onItemExpanded(expanded, record)
        }
    }

    onTableChange = (pagination, filters, sorter) => {
        this.setState({ expandedRows: [] });
        return this.props.onTableChange(pagination, filters, sorter)
    }

    collapseAllRow = () => {
        this.setState({ expandedRows: [] });
    }

}

RedeemtionList.defaultProps = {
    data: {},
    filters: {},
    loading: false,
    onTableChange: () => { },
    onItemExpanded: (expanded, redeemtion) => { },
    onDetailTableChange: (redeemtion, pagination, filters, sorter) => { },
}

